import React, { useCallback } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { List } from 'antd';
import { observer } from 'mobx-react';
import { RecordCard } from '@project/store/shared/RecordCard';

import '@assets/scss/index.scss';
import './style.scss';
import { RecordCardManager } from '../../../store/shared/RecordCardManager';
import { Card } from '../../../store/LinkController/Card';

export interface CardItemView {
  recordCard: RecordCard;
  cardCollection: RecordCardManager;
  activeCard: Card;
}

export const CardItem: React.FC<CardItemView> = observer(function CardItem({
  recordCard,
  cardCollection,
  activeCard,
}) {
  const layerDescription = recordCard.connectedLayer.error
    ? undefined
    : recordCard.connectedLayer.description ||
      recordCard.connectedLayer.layerName;

  const { partition, name } = recordCard.cardInfo;

  const handleClose = useCallback(
    (evt: React.MouseEvent<HTMLSpanElement>) => {
      evt.stopPropagation();
      cardCollection.deleteCardFromCollection(recordCard);
    },
    [cardCollection.deleteCardFromCollection, recordCard],
  );

  const handleItemClick = useCallback(() => {
    const { recordId, tableName } = recordCard;
    const layerName = recordCard.connectedLayer.layerName;

    activeCard.setCard({
      tableName,
      recordId: '' + recordId,
      layerName,
    });

    cardCollection.deleteCardFromCollection(recordCard);
  }, [cardCollection.deleteCardFromCollection, activeCard.setCard, recordCard]);

  return (
    <List.Item
      className={'card-collection-item'}
      onClick={handleItemClick}
      extra={<CloseOutlined onClick={handleClose} />}
    >
      <List.Item.Meta
        title={layerDescription || partition}
        description={name}
      />
    </List.Item>
  );
});
